
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SynthwaveGridEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const spacing = (100 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 2 * scale;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.3 / (layerIndex + 1);
             
             // Perspective grid
            for (let x = x1; x <= x2; x += spacing) {
                ctx.beginPath();
                ctx.moveTo(x, -height * 2);
                ctx.lineTo(x * 2.5, height * 2);
                ctx.stroke();
            }
            for (let y = y1; y <= y2; y += spacing) {
                const ty = y + (curTime * 100) % spacing;
                ctx.beginPath();
                ctx.moveTo(-width * 2, ty);
                ctx.lineTo(width * 2, ty);
                ctx.stroke();
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
